import { TextField } from '@mui/material';

/**
 * COMPONENTE
 * Adapter pattern per integrare TextField di Material-UI con React Final Form
 *
 * Scopo: Bridge component che mappa le props di React Final Form (input, meta)
 * alle props native di Material-UI TextField
 *
 * @param props - Oggetto contenente input, meta e altre props
 * @param props.input - Oggetto input di React Final Form (name, value, onChange, etc.)
 * @param props.meta - Oggetto meta di React Final Form (touched, error, etc.)
 * @param props.rest - Altre props passate al componente (label, placeholder, etc.)
 * @returns Componente TextField configurato per React Final Form
 */

export const TextFieldDialogAdapter = ({
  input: { name, value, onChange, onBlur, onFocus, ...restInput },
  meta,
  ...rest
}: any) => {
  const showError = Boolean(meta?.touched && meta?.error);

  return (
    <TextField
      {...rest}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      helperText={showError ? meta.error : ''}
      inputProps={restInput}
      error={showError}
      fullWidth
    />
  );
};
